<template>
  <span>
    <v-radio-group v-model="newOrExisting" @change="updateStep()">
      <v-radio value="new" label="Create a New MH1 Practice based on PMS Site Information"></v-radio>
      <v-radio value="existing" label="Use an Existing MH1 Practice"></v-radio>
    </v-radio-group>
    <v-expand-transition>
      <v-alert
        v-if="newOrExisting == 'new'"
        type="warning"
      >The ability to create a new MH1 Practice is under development.</v-alert>
    </v-expand-transition>
    <span v-if="newOrExisting == 'existing'">
      <v-autocomplete
        v-model="selectedMh1Practice"
        :items="items"
        :loading="isSearching"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        cache-items
        item-text="name"
        item-value="id"
        label="MyHealth1st Practice Search"
        placeholder="Start typing to Search MyHealth1st Practices by Name"
        prepend-icon="mdi-database-search"
        return-object
        @change="updateStep()"
      ></v-autocomplete>

      <v-divider></v-divider>
      <v-expand-transition>
        <v-alert type="error" v-if="practiceAlreadyLinked">
          This MH1 practice is already configured with this PMS Connector. Please manage it by following this link:
          <v-btn
            small
            :to="{ name: 'ManageMh1', params: { sub: $route.params.sub, mh1PracticeId: selectedMh1Practice.id }}"
          >Manage</v-btn>
        </v-alert>
      </v-expand-transition>

      <v-divider></v-divider>
      <v-expand-transition>
        <v-tabs v-if="selectedMh1Practice.id">
          <v-tab>Mh1 Practice Details</v-tab>
          <v-tab-item>
            <v-alert>
<a
                    :href="mh1BaseUri + 'practice/show/' +selectedMh1Practice.id"
                    target="_blank"
                  >View Practice in MH1</a><v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon></v-alert>
            <v-simple-table v-if="selectedMh1Practice">
              <template>
                <tbody>
                  <tr v-for="(field, i) in fields.sort(f => f.key)" :key="i">
                    <td>{{field.key}}</td>
                    <td>{{field.value}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
          <v-tab>Mh1 Appointment Books</v-tab>
          <v-tab-item>
            <v-list>
              <v-list-item v-for="book in appointmentBooks" :key="book.id">
                <v-list-item-icon>
                  <v-img :src="require('@/assets/mh1_icon.png')" width="32"></v-img>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{book.subscriber.name}} {{book.subscriber.surname}} - {{book.status}}</v-list-item-title>

                                    <a
                    :href="mh1BaseUri + 'appointmentBook/edit/' + book.id"
                    target="_blank"
                  >View Book in MH1<v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon></a>
                  
                </v-list-item-content>
                

                
                  
              </v-list-item>

            </v-list>
          </v-tab-item>

        </v-tabs>
      </v-expand-transition>
    </span>
  </span>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  name: "ChooseNewOrExisting",
  props: {
    value: Object,
    index: Number,
  },
  created: function () {
    // this is always valid as one feature has to be selected
    this.newOrExisting = this.value.newOrExisting;
  },

  data: function () {
    return {
      newOrExisting: "",
      selectedMh1Practice: {},
      search: "",
      entries: [],
      search: null,
      nameLimit: 100,
      isLoadingAppointmentBooks: false,
      isSearching: false,
      appointmentBooks: [],
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
    };
  },
  computed: {
    isLoading() {
      return this.isLoadingAppointmentBooks || this.isSearching;
    },
    fields() {
      if (!this.selectedMh1Practice) return [];

      return Object.keys(this.selectedMh1Practice).map((key) => {
        return {
          key,
          value: this.selectedMh1Practice[key] || "",
        };
      });
    },
    items() {
      return this.entries.map((entry) => {
        const description =
          entry.name.length > this.nameLimit
            ? entry.name.slice(0, this.nameLimit) + "..."
            : entry.name;

        return Object.assign({}, entry, { description });
      });
    },
    practiceAlreadyLinked() {
      if (!this.selectedMh1Practice) return false;

      const foundPractice = this.value.links.accounts.find(
        (a) => a.platform == "mh1" && a.accountId == this.selectedMh1Practice.id
      );
      console.log(
        "practiceAlreadyLinked found practice",
        this.selectedMh1Practice.id,
        foundPractice
      );
      return foundPractice ? true : false;
    },
  },
  methods: {
    updateStep: function () {
      this.$emit("input", {
        ...this.value,
        newOrExisting: this.newOrExisting,
        existingMh1PracticeId: this.selectedMh1Practice?.id ?? "",
        existingMh1Practice: this.selectedMh1Practice ?? {},
      });

      if (this.newOrExisting == "new" || this.selectedMh1Practice) {
        this.$emit("step-is-valid", true);
      }
    },
    async fetchEntriesDebounced() {
      // cancel pending call
      clearTimeout(this._timerId);

      // delay new call 500ms
      this._timerId = setTimeout(async () => {
        await this.fetch();
      }, 500);
    },
    async fetch() {
      this.isSearching = true;
      try {
        const searchResult = await API.graphql(
          graphqlOperation(queries.searchMh1Practices, {
            practiceName: this.search,
          })
        );

        console.log("fetch got", searchResult);

        if (!searchResult?.data?.searchMh1Practices) {
          console.log("did not get results", searchResult);
          this.entries = [];
          return;
        }

        this.entries = searchResult.data.searchMh1Practices;
      } catch (err) {
      } finally {
        this.isSearching = false;
      }
    },
    async fetchAppointmentBooks(mh1PracticeId) {
      this.isLoadingAppointmentBooks = true;
      try {
        const searchResult = await API.graphql(
          graphqlOperation(queries.getMh1PracticeAppointmentBooks, {
            practiceId: mh1PracticeId
          })
        );

        console.log("fetchAppointmentBooks got", searchResult);

        if (!searchResult?.data?.getMh1PracticeAppointmentBooks) {
          console.log("did not get results", searchResult);
          this.appointmentBooks = [];
          return;
        }

        this.appointmentBooks = searchResult.data.getMh1PracticeAppointmentBooks;
      } catch (err) {
      } finally {
        this.isLoadingAppointmentBooks = false;
      }
    },
  },
  watch: {
    selectedMh1Practice: {
      handler: async function(val, oldVal) {
        console.log("watch selectedMh1Practice", val, oldVal);
        if (val.id && val.id != oldVal.id) {
          await this.fetchAppointmentBooks(val.id);
        }
      },
      deep: true
    },
    async search(val) {
      if (!val) {
        return;
      }

      await this.fetchEntriesDebounced();
      /*
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      fetch("https://api.publicapis.org/entries")
        .then((res) => res.json())
        .then((res) => {
          const { count, entries } = res;
          this.count = count;
          this.entries = entries;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));*/
    },
  },
};
</script>